import { FC, useState } from "react";

import { Skeleton, Stack } from "@mui/material";
import Grid from "@mui/material/Grid";

import ChipComponent from "../../../common/components/chip/ChipComponent";
import { useGetDevicesByNode } from "../hooks/useGetDevicesByNode";

interface IConnectedDevicesColumnProps {
  nodeId: string;
}

const NodeConnectedDevicesColumn: FC<IConnectedDevicesColumnProps> = ({
  nodeId,
}) => {
  const [isShowMore, setIsShowMore] = useState(false);

  const onSetShowMoreHandler = () => setIsShowMore(prev => !prev);

  const { data, loading } = useGetDevicesByNode(nodeId);
  const devices = data?.getDevicesByNodeId?.items;

  if (loading) {
    return <Skeleton variant="text" width={100} height={20} />;
  }

  return (
    <Grid container spacing={1}>
      {devices?.map((device, index) => {
        if (index > 1 && !isShowMore) {
          return null;
        }

        return (
          <Grid item key={index}>
            <Stack spacing={1} direction="row" alignItems="center">
              {index === 1 && !isShowMore ? (
                <ChipComponent
                  menuBoxStyles={{
                    padding: "2px 0.5em",
                    color: theme => theme.typography.inputLabel.color,
                  }}
                  onClick={onSetShowMoreHandler}
                  label={`+${devices.length - 1}`}
                />
              ) : (
                <ChipComponent
                  menuBoxStyles={{
                    padding: "2px 0.5em",
                  }}
                  label={device?.name ?? ""}
                  routeLink={`/device/${encodeURIComponent(device?.id ?? "")}`}
                />
              )}

              {index === devices?.length - 1 && isShowMore && (
                <ChipComponent
                  menuBoxStyles={{
                    padding: "2px 0.5em",
                    color: theme => theme.palette.primary.dark,
                  }}
                  onClick={onSetShowMoreHandler}
                  label={"Show less"}
                />
              )}
            </Stack>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default NodeConnectedDevicesColumn;
